















import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { envCongif } from './../../shared/env.config';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'catalog-login-opt';
@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class MswCatalogLoginOptions extends SwExtendedVue {
  cssPrefix = cssPrefix;

  goToCart() {
    this.$router.push('feature/cart');
  }

  goToAccounts() {
    const url: URL = new URL(`${envCongif.accounts_url}`);
    url.searchParams.set('RESPONSETYPE', 'TOKEN');
    url.searchParams.set('CLIENTID', 'MUIR1XHIS27');
    url.searchParams.set('REDIRECTURL', `${window.location.origin}/muir/login`);
    const redirectPage = btoa(`${window.location.origin}/workspace/m/feature/cart`);
    url.searchParams.set('REDIRECTPAGE', redirectPage);
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    url.searchParams.set('gbsid', userInfoObtained.sessionId);
    window.location.href = url.toString();
  }
}
